export default __webpack_public_path__ + "static/media/sixteen.c4cab505.png";